import React from 'react'
import Grid from '@mui/material/Grid'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const ControlMethods = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <Autocomplete
      multiple
      freeSolo
      options={[
        'Direct Pressure',
        'Tourniquet',
        'Hemostatic Dressing',
        'Wound Packing',
        'Elevation',
      ]}
      label="Control Methods"
      value={moduleValues?.['Control Methods'] ?? []}
      onChange={(e, value) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Control Methods']: value,
        }))
      }
      renderInput={(params) => (
        <TextField {...params} fullWidth label="Control Methods" />
      )}
    />
  </Grid>
)

export default ControlMethods
